(() => {
  if (window.sasTeamPersonalizationLoaded) return;
  window.sasTeamPersonalizationLoaded = true;
  const setup = root => root.querySelectorAll('[data-sas-personalization]').forEach(box => {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    const form = box.closest('form');
    if (!form) return;
    const fields = ['name', 'number'].map(type => ({type,choice:box.querySelector(`[data-sas-choice="${type}"]`),input:box.querySelector(`[data-sas-${type}]`),label:box.querySelector(`[data-sas-${type}-label]`),variant:Number(box.dataset[type + 'Variant'])})).filter(field => field.choice && field.input && field.label);
    const price = box.querySelector('[data-sas-price]');
    const error = box.querySelector('[data-sas-error]');
    const update = () => {
      let total = 0;
      fields.forEach(f => {const chosen=f.choice.checked; f.input.disabled=!chosen; f.input.hidden=!chosen; f.label.hidden=!chosen; f.input.required=chosen; if(chosen) total += f.type === 'name' ? 7 : 5;});
      price.textContent = total ? `Personalization: +$${total.toFixed(2)} per item.` : 'No personalization added.';
    };
    fields.forEach(f => {
      f.choice.addEventListener('change', () => {f.input.setCustomValidity(''); update();});
      f.input.addEventListener('input', () => f.input.setCustomValidity(''));
    });
    update();
    window.addEventListener('submit', async event => {
      if (event.target !== form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.sasSubmitting) return;
      fields.forEach(f => f.input.setCustomValidity(f.choice.checked && !f.input.value.trim() ? 'Please enter the text to print.' : ''));
      if (!form.reportValidity()) return;
      const data = new FormData(form);
      const id = Number(data.get('id'));
      const quantity = Math.max(1, Number(data.get('quantity')) || 1);
      const selected = fields.filter(f => f.choice.checked);
      const properties = {};
      for (const [key,value] of data.entries()) {
        const property = key.match(/^properties\[(.+)\]$/);
        if (property && typeof value === 'string' && value.trim()) properties[property[1]] = value.trim();
      }
      const group = 'sas-' + crypto.randomUUID();
      if (selected.length) properties._sas_personalization_group = group;
      selected.forEach(f => { properties[f.type === 'name' ? 'Personalization' : 'Team Number'] = f.input.value.trim(); });
      const parent = {id,quantity,properties};
      if(data.get('selling_plan')) parent.selling_plan=data.get('selling_plan');
      const items = [parent,...selected.map(f => ({id:f.variant,quantity,parent_id:id,properties:{'Print text':f.input.value.trim(),_sas_personalization_group:group}}))];
      const button = form.querySelector('[type="submit"]');
      error.hidden = true;
      form.dataset.sasSubmitting = '1';
      if(button) button.disabled=true;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if(!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'The item could not be added. Please try again.');
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (failure) {
        error.textContent = failure.message || 'The item could not be added. Please try again.';
        error.hidden = false;
        delete form.dataset.sasSubmitting;
        if(button) button.disabled=false;
      }
    }, true);
  });
  setup(document);
  new MutationObserver(() => setup(document)).observe(document.documentElement,{childList:true,subtree:true});
})();
